// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__3ZnAh","label":"Category_label__1Ll_v","content":"Category_content__1S1DO","header":"Category_header__JoGi0","location":"Category_location__mUkYv"};